/**
 * The copy of dated fields (1.Y stage s1), pure: every label, notice and refusal in US English, so
 * the report's Decisions list one file. Titles and values are shown as the GM wrote them.
 */

export const CHANGE = 'Change';
export const ADD = 'Add';
export const END = 'End';
export const HISTORY = 'History';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';
export const SINCE_LABEL = 'Since';
export const NONE_NOW = 'None now';
export const NO_VALUES = 'No values yet.';
export const NOW_UNSET_NOTICE = "NOW isn't set yet, so every value is shown.";
export const NOW_UNSET_SINCE = "NOW isn't set yet, so type the date the value starts.";
export const VALUES_FAILED = "The dated values couldn't be loaded.";
export const CONFLICT = "This value changed elsewhere. Your change wasn't saved.";
export const PAGE_LABEL = 'Page';
export const CHOOSE_PAGE = 'Choose a page from the list.';
export const NO_PAGES = 'No canon page matches.';
export const UNTITLED = 'Untitled';
export const UNKNOWN_DATE = 'an unknown date';
export const ALWAYS = 'Always';
export const LINK_TYPE_UNREAD = "This field's link type can't be read.";

/** "Since 9 Ember 1042". */
export const sinceText = (date: string): string => `Since ${date}`;
/** "Until 9 Ember 1042". */
export const untilText = (date: string): string => `Until ${date}`;
/** "9 Ember 1042 to 14 Ember 1042". */
export const betweenText = (from: string, to: string): string => `${from} to ${to}`;
/** "around 2 Thaw 1041", for an edge of another page's date. */
export const aroundText = (date: string): string => `around ${date}`;

export const updatedNotice = (label: string): string => `Updated ${label}.`;
export const changeLabel = (label: string): string => `Change ${label}`;
export const addLabel = (label: string): string => `Add to ${label}`;
export const endLabel = (title: string): string => `End ${title}`;
export const historyTitle = (label: string): string => `History of ${label}`;

/** The refusal of a "since" before the current value began. */
export const startsTooEarly = (date: string): string =>
  `The new value must start after the current one began (${date}).`;

/** The refusal of End on a value that has already ended. */
export const ALREADY_ENDED = 'This value has already ended.';

// --------------------------------------------------------------------------- the Dated toggle

export const DATED_LABEL = 'Dated: keeps a history of values';
export const DATED_DESCRIPTION = 'Changes are recorded with an in-world date.';

// ------------------------------------------------------------------------ the world-date editor

export const SET_DATE = 'Set date';
export const EDIT_DATE = 'Edit date';
export const CLEAR = 'Clear';
export const CLEAR_TITLE = 'Clear this date?';
export const CLEAR_BODY = 'The page keeps its other dates.';
export const NO_DATE = 'No date yet.';
export const DATE_LABEL = 'Date';
export const dateSaved = (label: string): string => `Saved ${label}.`;
export const dateCleared = (label: string): string => `Cleared ${label}.`;
